import React from "react";
import { FiShoppingBag } from "react-icons/fi";
import "./orderDetail.css";

const OrderDetailHeader = ({ orderName, subtitle = "Teklif Detayı" }) => (
  <div className="d-flex align-items-center gap-2">
    <div className="order-detail-modal-icon-box">
      <FiShoppingBag />
    </div>
    <div>
      <h5 className="mb-0">{orderName || "-"}</h5>
      <small className="text-muted">{subtitle}</small>
    </div>
  </div>
);

export default OrderDetailHeader;
